module.exports = __webpack_public_path__ + "img/driver-black.ec111a0a.svg";